import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from './components/login/Login';
import RecoverPassword from './components/login/RecoverPassword';
import ResetPassword from './components/login/ResetPassword';
import Mentor from "./components/register/Mentor";
import Alumno from "./components/register/Alumno";
import Mentoring from "./components/mentoring/Mentoring";
import ListaMentores from "./components/mentoring/ListaMentores";
import ListaAlumnos from "./components/mentoring/ListaAlumnos";
import Perfil from "./components/mentoring/Perfil";
import Evaluacion from "./components/mentoring/Evaluacion";
import MatchFromStudent from "./components/mentoring/MatchFromStudent";
import MatchFromTeacher from "./components/mentoring/MatchFromTeacher";

import AuthState from "./context/authentication/authState";
import TeacherState from "./context/teacher/teacherState";
import StudentState from "./context/student/studentState";
import EvaluationState from "./context/evaluation/evaluationState";
import tokenAuth from "./config/tokenAuth";
import RutaPrivada from "./components/rutas/RutaPrivada";

const token = localStorage.getItem('token');
if ( token ) {
    tokenAuth()
}

function App() {
    return (
        <EvaluationState>
            <TeacherState>
                <StudentState>
                    <AuthState>
                        <Router>
                            <Switch>
                                <Route exact path="/" component={Login} />
                                <Route exact path="/recoverPassword" component={RecoverPassword} />
                                <Route exact path="/resetPassword/:hash" component={ResetPassword} />
                                <Route exact path="/mentoresRegistro" component={Mentor} />
                                <Route exact path="/alumnosRegistro" component={Alumno} />
                                <RutaPrivada exact path="/mentorias" component={Mentoring} />
                                <RutaPrivada exact path="/listaMentores" component={ListaMentores} />
                                <RutaPrivada exact path="/listaAlumnos" component={ListaAlumnos} />
                                <RutaPrivada exact path="/Perfil" component={Perfil} />
                                <RutaPrivada exact path="/evaluacion" component={Evaluacion} />
                                <RutaPrivada exact path="/editTeacher" component={Mentor} />
                                <RutaPrivada exact path="/editStudent" component={Alumno} />
                                <RutaPrivada exact path="/mentorAsignado" component={MatchFromStudent} />
                                <RutaPrivada exact path="/alumnosAsignados" component={MatchFromTeacher} />
                            </Switch>
                        </Router>
                    </AuthState>
                </StudentState>
            </TeacherState>
        </EvaluationState>
    );
}

export default App;